import { useRef } from "react"

/**
 * Holds the last complete contributors dataset under a stable key (asOf token stripped).
 * When the key changes due to an intraday tick, useQueries briefly enters a pending state
 * with no data. This hook returns the previous dataset so the component stays visible
 * during the refresh instead of flashing a skeleton.
 *
 * Uses a render-time ref write (same pattern as useIntradayEnhancement) to avoid an
 * extra useState re-render cycle.
 */
export function useStableContributorsCache<T>(
  stableKey: string,
  data: T | null,
  isAnyQueryPending: boolean,
): T | null {
  const cacheRef = useRef<{ key: string, data: T } | null>(null)

  if (!isAnyQueryPending && data !== null) {
    cacheRef.current = { key: stableKey, data }
  }

  return cacheRef.current?.key === stableKey ? cacheRef.current.data ?? null : null
}
